<template>
  <div class="snackbar-verification">
    <s-ticker
      id="ticker-verification"
      variant="warning"
      action-text="Verifikasi"
      cluster="k"
      @click="verify()"
    >
      Verifikasi akun Anda sekarang agar dapat mengakses seluruh fitur di Karier.mu.
    </s-ticker>
  </div>
</template>
<script>
import deviceDetector from 'mobile-device-detect'

export default {
  name: 'SnackbarVerification',
  data () {
    return {
      isMobile: deviceDetector.isMobile
    }
  },
  computed: {
    isTemporarilyFreezeOtpVerification () {
      return this.$store.state.user.isTemporarilyFreezeOtpVerification
    },
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    verify () {
      this.$emit('triggerVerification')
      let event = 'verifikasi_voluntary_profil_click'
      if (this.textShowType === 'wasDisabled') {
        event = 'verifikasi_voluntary_post_freeze_click'
      }
      window.firebaseAnalytics.logEvent(event, {
        screen_url: window.location.href,
        user_profession: this.userInfo.profession_name,
        user_year_level: this.userInfo.year_level_name,
        user_is_admin: this.userInfo.is_admin,
        user_id: this.userInfo.id,
        source: this.isMobile ? 'web_mobile_kariermu' : 'web_kariermu'
      })
    }
  }
}
</script>
